// extracted by mini-css-extract-plugin
export default {"delayed-transition-opacity":"App_delayed-transition-opacity__-FNkd"};